import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { uiModes } from 'utils/interfaces/store/ui.interfaces';

import { RootState } from '../store';

interface UiState {
  uiState: {
    showPasswordLogin: boolean;
    showNewPassword: boolean;
    showConfirmNewPassword: boolean;
    mode: uiModes;
  };
}

export const initialState: UiState = {
  uiState: {
    showPasswordLogin: false,
    showNewPassword: false,
    showConfirmNewPassword: false,
    mode: uiModes.DARK,
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setShowPassword(state, action: PayloadAction<'login' | 'newPassword' | 'confirmNewPassword'>) {
      switch (action.payload) {
        case 'login':
          state.uiState.showPasswordLogin = !state.uiState.showPasswordLogin;
          break;
        case 'newPassword':
          state.uiState.showNewPassword = !state.uiState.showNewPassword;
          break;
        case 'confirmNewPassword':
          state.uiState.showConfirmNewPassword = !state.uiState.showConfirmNewPassword;
          break;
        default:
          break;
      }
    },
    setUiMode(state, action: PayloadAction<uiModes>) {
      state.uiState.mode = action.payload;
    },
  },
});

export const { setShowPassword, setUiMode } = uiSlice.actions;

export const selectUi = (state: RootState) => state.ui.uiState;

export default uiSlice.reducer;
